import styled from 'styled-components';
import BaseInput from './BaseInputText';
const BaseInputSelect = styled(BaseInput) `
  display: flex;
  justify-content: space-between;
`;
export default BaseInputSelect;
//# sourceMappingURL=BaseInputSelect.js.map